// extracted by mini-css-extract-plugin
export default {"rightSidebar":"RightSidebar_rightSidebar__+NX0-"};